import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const match = location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }
    exchangeGoogleSession(sessionId)
      .then((u) => {
        // remove hash, go to app
        window.history.replaceState(null, "", "/app");
        toast.success(`Welcome, ${u.name || u.email}`);
        navigate("/app", { replace: true });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        navigate("/auth", { replace: true });
      });
  }, [exchangeGoogleSession, location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]" data-testid="auth-callback">
      <Loader2 className="w-6 h-6 animate-spin text-zinc-500" />
    </div>
  );
}
